import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token')
      window.location.href = '/signin'
    }
    return Promise.reject(error)
  }
)

export const teamAPI = {
  // Get team members
  getTeamMembers: async () => {
    try {
      const response = await api.get('/api/team/members')
      return response.data
    } catch (error) {
      console.error('Error fetching team members:', error)
      throw error
    }
  },

  // Get team invitations
  getTeamInvitations: async () => {
    try {
      const response = await api.get('/api/team/invitations')
      return response.data
    } catch (error) {
      console.error('Error fetching team invitations:', error)
      throw error
    }
  },

  // Delete team member
  deleteTeamMember: async (memberId) => {
    try {
      const response = await api.delete(`/api/team/members/${memberId}`)
      return response.data
    } catch (error) {
      console.error('Error deleting team member:', error)
      throw error
    }
  },

  // Invite member (sends email)
  inviteMember: async (data) => {
    try {
      const { email, name, role } = data
      const response = await api.post('/api/team/invite', { email, name, role })
      return response.data
    } catch (error) {
      console.error('Error inviting member:', error)
      throw error
    }
  },

  // Accept invitation (public; no auth)
  acceptInvitation: async (invitation_token, password) => {
    try {
      const response = await api.post('/api/team/accept-invitation', {
        invitation_token,
        password
      })
      return response.data
    } catch (error) {
      console.error('Error accepting invitation:', error)
      throw error
    }
  },

  // Resend invitation
  resendInvitation: async (invitationId) => {
    try {
      const response = await api.post(`/api/team/invitations/${invitationId}/resend`)
      return response.data
    } catch (error) {
      console.error('Error resending invitation:', error)
      throw error
    }
  },


  // Update team member
  updateTeamMember: async (memberId, updateData) => {
    try {
      const response = await api.put(`/api/team/members/${memberId}/role`, updateData)
      return response.data
    } catch (error) {
      console.error('Error updating team member:', error)
      throw error
    }
  }
}

export default teamAPI
